<div class="subject-header__title">
  <div class="subject-header__title-text" [style.color]="color()">{{ subject() }}</div>
</div>
<div class="subject-header__footer"></div>
